"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var defaultState = buildFormState({});
var defaultActions = {
    setAllValues: function () { return console.warn('FormProvider not used'); },
    setAllErrors: function () { return console.warn('FormProvider not used'); },
    setAllTouched: function () { return console.warn('FormProvider not used'); },
    setValue: function () { return console.warn('FormProvider not used'); },
    setError: function () { return console.warn('FormProvider not used'); },
    setTouched: function () { return console.warn('FormProvider not used'); },
};
exports.FormContext = react_1.createContext([defaultState, defaultActions]);
function useFormContext() {
    return react_1.useContext(exports.FormContext);
}
exports.useFormContext = useFormContext;
function useFormValidationContext() {
    return react_1.useContext(exports.FormContext);
}
exports.useFormValidationContext = useFormValidationContext;
var FormProvider = /** @class */ (function (_super) {
    __extends(FormProvider, _super);
    function FormProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.actions = _this.buildActions();
        _this.state = buildFormState(props.initial);
        return _this;
    }
    FormProvider.prototype.setAllValues = function (values, cb) {
        this.setState(function (state) { return (__assign(__assign({}, state), { values: values })); }, cb);
    };
    FormProvider.prototype.setAllErrors = function (errors, cb) {
        this.setState(function (state) { return (__assign(__assign({}, state), { errors: errors })); }, cb);
    };
    FormProvider.prototype.setAllTouched = function (touched, cb) {
        this.setState(function (state) { return (__assign(__assign({}, state), { touched: touched })); }, cb);
    };
    FormProvider.prototype.setValue = function (name, value, cb) {
        this.setState(function (state) {
            var _a;
            return (__assign(__assign({}, state), { values: __assign(__assign({}, state.values), (_a = {}, _a[name] = value, _a)) }));
        }, cb);
    };
    FormProvider.prototype.setError = function (name, value, cb) {
        this.setState(function (state) {
            var _a;
            return (__assign(__assign({}, state), { errors: __assign(__assign({}, state.errors), (_a = {}, _a[name] = value, _a)) }));
        }, cb);
    };
    FormProvider.prototype.setTouched = function (name, cb) {
        this.setState(function (state) {
            var _a;
            return (__assign(__assign({}, state), { touched: __assign(__assign({}, state.touched), (_a = {}, _a[name] = true, _a)) }));
        }, cb);
    };
    FormProvider.prototype.buildActions = function () {
        return {
            setAllValues: this.setAllValues.bind(this),
            setAllErrors: this.setAllErrors.bind(this),
            setAllTouched: this.setAllTouched.bind(this),
            setValue: this.setValue.bind(this),
            setError: this.setError.bind(this),
            setTouched: this.setTouched.bind(this),
        };
    };
    FormProvider.prototype.render = function () {
        var _a = this, state = _a.state, actions = _a.actions, props = _a.props;
        return (react_1.default.createElement(exports.FormContext.Provider, { value: [state, actions] }, typeof props.children === 'function'
            ? props.children(state, actions)
            : props.children));
    };
    return FormProvider;
}(react_1.Component));
exports.FormProvider = FormProvider;
function buildFormState(initial) {
    var values = initial;
    var errors = {};
    var touched = {};
    return {
        initial: initial,
        values: values,
        errors: errors,
        touched: touched,
    };
}
//# sourceMappingURL=context.js.map